import axios from 'axios';
import Vue from 'vue'
import store from '@/services/store'
import router from '../router'

const gateway = axios.create({
  baseURL: '/api'
})

gateway.install = function(Vue) {
  Vue.prototype.$gateway = gateway
}

gateway.interceptors.response.use(response => response, (error) => handleError(error))

export default gateway

export let handleError = error => {
  if (error.response.status === 401) {
    store.dispatch('logout')
    if (router.currentRoute.path !== '/' && router.currentRoute.path != '/login') {
      Vue.prototype.$notifications.warning('Teie sessioon aegus.')
      router.push('/login')
    }
  } else if (error.response.status === 403) {
    Vue.prototype.$notifications.error('Ligipääs puudub!')
  } else if (error.response.status !== 468) {
    Vue.prototype.$notifications.error('Server ei tööta ootuste kohaselt, veakood '+ error.response.status)
  }
  return Promise.reject(error)
}
